import React from 'react';

import { Box, Icon } from '@rbilabs/universal-components';

import { DELIVERY_PROGRESS_COLOR } from './constants';

interface ProgressCheckpointProps {
  isActive: boolean;
  whiteVariant?: boolean;
}

const ProgressCheckpoint: React.FC<ProgressCheckpointProps> = ({ isActive, whiteVariant }) => {
  const variant = whiteVariant && !isActive ? 'checkMarkWhite' : 'checkMark';
  return (
    <Box>
      <Icon variant={variant} color={isActive ? DELIVERY_PROGRESS_COLOR : Styles.color.grey.five} />
    </Box>
  );
};

export default ProgressCheckpoint;
